<template>
  <div>
    <Worktemp
      data-aos="fade-down"
      :workTitle="work.tittle"
      :workPara="work.para"
      :companyName="work.company"
      :yearName="work.year"
      :projectType="work.project"
    ></Worktemp>
    <WorkcoverImg :coverimg="work.coverimg" data-aos="fade-up" />
    <WorkTwoImg :TwoImgleft="work.TwoImgleft" :TwoImgRight="work.TwoImgRight" />
    <WorkThreeImg
      :ThreeImgleft="work.ThreeImgleft"
      :ThreeImgRight="work.ThreeImgRight"
    />
    <WorkcoverImg :coverimg="work.coverimg2" />
    <hire />
  </div>
</template>
<script>
import Worktemp from "@/components/Worktemp.vue";
import WorkcoverImg from "@/components/WorkcoverImg.vue";
import WorkTwoImg from "@/components/WorkTwoImg.vue";
import WorkThreeImg from "@/components/WorkThreeImg.vue";
export default {
  components: {
    Worktemp,
    WorkcoverImg,
    WorkTwoImg,
    WorkThreeImg,
  },
  data() {
    return {
      work: {
        tittle: "Healing Gardens",
        para: "Healing Gardens is a US-based booming start-up lending gardens for different activities. I did UI design for the different modules of the website while working at Cobold Digital. Easy to navigate, super-smooth user flow & scalable design, everything was well reflected in the design. The bonus was to try my hands on Webflow.",
        company: "Healing Gardens",
        year: "2021",
        project: "UI/UX",
        coverimg: "/img/gallery/ui/healinggardens/cover.jpg",
        TwoImgleft: "/img/gallery/ui/healinggardens/twoimg.svg",
        TwoImgRight: "/img/gallery/ui/healinggardens/tworight.svg",
        ThreeImgleft: "/img/gallery/ui/healinggardens/threeleft.svg",
        ThreeImgRight: "/img/gallery/ui/healinggardens/threeright.svg",
        coverimg2: "/img/gallery/ui/healinggardens/cover2.jpg",
      },
    };
  },
};
</script>
